import { OnboardingRootState } from "../reducers/rootReducer";
import { initialXboxOnboardState, XboxOnboardState } from "../reducers/xboxOnboardReducer";
import { getOnboardingState } from "./rootSelectors";

export const getXboxOnboardState = (state: OnboardingRootState): XboxOnboardState =>
  getOnboardingState(state)?.xboxOnboard ?? initialXboxOnboardState;

export const getXboxOnboardData = (state: OnboardingRootState) => getXboxOnboardState(state).data;

export const getXboxOnboardIsLoading = (state: OnboardingRootState) =>
  getXboxOnboardState(state).isLoading;

export const getXboxOnboardIsSubmitting = (state: OnboardingRootState) =>
  getXboxOnboardState(state).isSubmitting;

export const getXboxOnboardError = (state: OnboardingRootState) => getXboxOnboardState(state).error;
